import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const NonElectiveContribution = () => {
  const formBag = useFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.EmployerNonElectiveContribution"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Non-elective Employer Contribution"
          maxLength={6}
        />
      )}
    />
  );
};
